import {deserialize, serialize, inheritSerialization, deserializeAs} from "cerialize";

import BaseEntity from "./BaseEntity";
import AspekBankSoal from "./AspekBankSoal";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";

@inheritSerialization(BaseEntity)
export default class BankSoal extends BaseEntity {

    @serialize
    @deserialize
    public nama: string = "";

    @serialize
    @deserialize
    public pendidikan: string = "";

    @serialize
    @deserialize
    public tahun: string = "";

    @deserialize
    public total_detail: number = 0;

    @serialize
    @deserializeAs(AspekBankSoal)
    public aspeks: Array<AspekBankSoal> = [];

    public namaFeedback() {
        return this.defaultPropertyFeedback("nama");
    }

    public pendidikanFeedback() {
        return this.defaultPropertyFeedback("pendidikan");
    }

    public tahunFeedback() {
        return this.defaultPropertyFeedback("tahun");
    }

    public fileFeedback(file: any = null) {
        return this.defaultPropertyFeedback("file", Boolean(file));
    }

    public table() {
        const {nama, pendidikan, tahun, total_detail} = this;

        return {nama, pendidikan, tahun, total_detail};
    }

    public static columnName(): Array<TableColumn> {
        const table = new BankSoal().table();
        const keys = Object.keys(table);

        return keys.map((field: string) => {
            const tableColumn = new TableColumn();
            tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

            if (field === "pendidikan" || field === "tahun" || field === "total_detail") {
                tableColumn.position = "centered";
            }

            return tableColumn;
        });
    }

}
